// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2wl0Q","legacyBtn":"MutateMid_legacyBtn__3NAio"};